module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-circle"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 100 100"
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.pathString,
      "stroke": _vm.trailColor,
      "stroke-width": _vm.trailWidth,
      "fill-opacity": 0
    }
  }), _vm._v(" "), _c('path', {
    style: (_vm.pathStyle),
    attrs: {
      "d": _vm.pathString,
      "stroke-linecap": _vm.strokeLinecap,
      "stroke": _vm.strokeColor,
      "stroke-width": _vm.strokeWidth,
      "fill-opacity": "0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vux-circle-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-070e4a0b"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/x-circle/index.vue
// module id = 462
// module chunks = 4